import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Toolbar as MuiToolbar } from '@mui/material';

export const Toolbar = forwardRef(({ className, children, style }, ref) => (
  <MuiToolbar
    className={className}
    style={{
      paddingLeft: '16px',
      paddingRight: '16px',
      ...style,
    }}
    ref={ref}
  >
    {children}
  </MuiToolbar>
));

Toolbar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
